// @ts-nocheck
import React from 'react';

const SelectionBox = ({ selected }: { selected: boolean }) =>
  selected ? <i className="fas fa-check-square checked" /> : <i className="far fa-square" />;

export default SelectionBox;
